var TRANSLATIONS = TRANSLATIONS || {};
// englisch -----------------------
TRANSLATIONS.en = {
  MATH: {
    FRACTION: '.'
  },
  OK: 'OK',
  YES: 'Yes',
  NO: 'No',
  TITLE: 'Olivio Configurator',
  PREVIOUS: 'return',
  NEXT: 'continue',
  CLOSE: 'close',
  RESET: 'reset',
  CANCEL: 'cancel',
  APPLY: 'continue',
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOAD: 'load',
  WARNING: 'warning',
  DOWNLOAD1: 'Finalize configuration and',
  DOWNLOAD2: 'create spec sheet',
  PLEASE_ASK: 'please ask',
  STEPS: {
    PRODUCT: 'Design line',
    DESIGN: 'Shape',
    CHARGING: 'Charging station',
    ASSEMBLY: 'Technical characteristics',
    DISTRIBUTION: 'Technical characteristics',
    COLOR: 'Technical characteristics',
    POWER: 'Technical characteristics',
    DETAILS: 'Details',
    CHECKOUT: 'Checkout'
  },
  DESIGN: {
    SIDEVIEW: 'Select pole and light spot height',
    TOPVIEW: 'Select quantity and arrangement around the pole\'s axis',
    CHOOSE_BOOM: 'Select bracket',
    CHOOSE_LUMINAIRE: 'Select luminaire size',
    NOCHOOSE_LUMINAIRE: 'Luminaire size',
    LUMINAIRES: 'Luminaire heads',
    DESIGN: 'Design',
    MAST_TYPE: 'Mast type',
    MAST_HEIGHT: 'Pole height',
    LUM_HEIGHT_TOP: 'Height of highest light spot',
    LUM_HEIGHT_BOTTOM: 'Height of lowest light spot',
    LUM_HEIGHT: 'luminaire height',
    DEGREE_START: 'Start angle',
    DEGREE_ROTATION: 'Segment angle',
    DEGREE_LUM: 'luminaire angle',
    LUM_NUMBER: 'Quantity of luminare heads',
    MAST_MATERIAL: 'Pole made of',
    MAST_MATERIAL_HOLZ: 'wood',
    MAST_MATERIAL_METALL: 'metal',
    COLOR: 'Finish',
    COLOR_ALL: 'Finisch pole, luminaire head or inlay',
    COLOR_OUTSIDE: 'Finisch pole or luminaire head',
    COLOR_WOODPOLE: 'Wood type pole',
    COLOR_MAST: 'Finish pole',
    COLOR_INLAY: 'Finish inlay',
    COLOR_LUM: 'Finish luminaire head',
    BOOM_TYPE: 'Type bracket',
    LUM_TYPE: 'Type luminaire head',
    COLOR_INFO: 'Please drag and drop the colour boxes to select your colour and click continue.',
    UNITS: "units",
    DOOR: "door",
    TOPVIEWBACKGROUND: "images/design_topviewbg_eng.svg",
    ADVANCED_LOADCONFIG: "Load Configuration (SX)",
    ADVANCED_LEAVE: "Leave Advanced Mode",
    ADVANCED_SETTINGSLOST: "Advanced Settings will get lost",
    BASE: "base plate",
    GOBO: "choose Gobo",
    CHOOSE_GOBO: "Choose Gobo",
    GOBO_INFO_HEAD: 'Gobo',
    GOBO_INFO_STANDARD_HEAD: 'standard lens\n(85mm)',
    GOBO_INFO_TELE_HEAD: 'telephoto lens\n(150mm)',
    GOBO_INFO_WIDE_HEAD: 'wide-angle lens\n(63mm)',
    GOBO_INFO_EXTRAWIDE_HEAD: 'extra-wide lens\n(45mm)',
    GOBO_INFO_STANDARD_TEXT: 'A medium focal length is suitable '+
    'for most situations. '+
    'The standard lens generates a '+
    'projection with a diameter of approx. '+
    '4.5 m from a distance of 10m.',
    GOBO_INFO_TELE_TEXT: 'A telephoto lens with a larger focal length '+
    'creates smaller projections with '+
    'more intensive light, thereby '+
    'enabling a bright projection over '+
    'large distances. From a distance '+
    'of 10 m it generates a projection '+
    'with a diameter of approx. 2.5m.',
    GOBO_INFO_WIDE_TEXT: 'A wide-angle lens enlarges the '+
    'subject. In doing so the light quantity '+
    'is dispersed across a larger surface so '+
    'that the projection appears darker. From a '+
    'distance of 10m it will generate a '+
    'projection with a diameter of approx. 6.5m.',
    GOBO_INFO_EXTRAWIDE_TEXT: 'A lens of this type enables an '+
    'extra wide focal distance - with '+
    'particularly short distances to the '+
    'projection surface. From a distance of '+
    '10m it will generate a projection '+
    'with  a diameter of approx. 8.75m.',
    GOBO_INFO_LOOKBOOK: 'Lookbook',
    GOBO_INFO_LOOKBOOK_URL: ' http://www.selux.com/lookbook/olivio-gobo-en_ger/',
    CHARGING_NUMBER: 'Quantity of charging stations',
    CHARGING_TYPE: 'Type charging station',
    CHARGING_POWER: 'Charging power',
    ANCHOR: 'buried base',
    ANCHOR_WO: 'without',
    ANCHOR_WITH: 'with'
  },
  CHARGING: {
    QUESTION: 'Do you want to add a charging station?',
    TOPVIEW: 'Select quantity and arrangement around the pole\'s axis',
    CHOOSE_TYPE: 'Select type of charging stations',
    CHOOSE_POWER: 'Select charging power',
    charging: 'charging station',
    chargings: 'charging stations',
    CHARGING_BASIC: 'Basic',
    CHARGING_ADV: 'Advanced',
    CHARGING_PROF: 'Professional',
    CHECKOUT: 'Charging stations'
  },
  ASSEMBLY: {
    TITEL: 'Lamp',
    LED: 'LED',
    LED_DESCRIPTION: '',
    HIT: 'HIT',
    HIT_DESCRIPTION: '',
    CPO: 'CPO',
    CPO_DESCRIPTION: ''
  },
  DISTRIBUTION: {
    TITEL: 'Distribution',
    ASYMETRIC: 'Asymmetric',
    SPOT: 'Spot',
    MEDIUM: 'Medium',
    FLOOD: 'Flood',
    TYP2: 'Typ II',
    TYP5: 'Typ V'
  },
  GOBO: {
    TITEL: "Grande Gobo LED, Ø 205, Light colour 6500K, Power 49W",
    EXTRAWIDE: 'Extra wide',
    WIDE: 'Wide angle',
    STANDARD: 'Standard',
    TELE: 'Telephoto'
  },
  COLOR: {
    TITEL: 'Light colour',
    COL2700K: '2700K',
    COL2700K_DESCRIPTION: '',
    COL3000K: '3000K',
    COL3000K_DESCRIPTION: 'warm white',
    COL4000K: '4000K',
    COL4000K_DESCRIPTION: 'neutral white',
    COL4200K: '4200K',
    COL4200K_DESCRIPTION: '',
    COL5300K: '5300K',
    COL5300K_DESCRIPTION: '',
    RGBW: 'RGBW',
    RGBW_DESCRIPTION: 'multi-coloured',
    MONOCHROME: 'plain-coloured',
    MONOCHROME_DESCRIPTION: '',
    INFO: '(en) Die Lichtfarbe kann nur bei LED-Bestückung gewählt werden.',
    BACK: 'Change lamp',
    SKIP: 'skip',
  },
  POWER: {
    TITEL: 'Power',
  },
  CHECKOUT: {
    SURCHARGE: 'Surcharge for finish',
    OPENINBROWSSER: 'view and edit this configuration in browser',
    SPECSHEET: 'Specsheet',
    PRINT: 'Print',
    DOWNLOAD_PDF: 'PDF',
    DOWNLOAD_DXF_SIDE: 'DXF Side',
    DOWNLOAD_DXF_TOP: 'DXF Top',
    DOWNLOAD_DXF_ZIP: 'DXF',
    DOWNLOAD_LDT_ZIP: 'LDT',
    CUSTOMIZE: 'Customize',
    MANUAL: 'Mounting',
    CONFIGURATION: 'Configuration',
    CONFIGNUMBER: 'Configuration number',
    ARRANGMENT: 'Arrangement',
    SINGLELEVEL: 'single level',
    STAGGERDLEVEL: 'various staggered levels',
    SEEPAGETWO: 'see page two for details',
    CONTACTINTRO: 'For further details or individual configurations, please feel free to contact us.',
    REQUESTQUOTE: 'REQUEST PERSONAL OFFER',
    INFOLINE1: 'Modifications are possible due to the constant development and improvement of LED technology.',
    INFOLINE2: '© Selux GmbH, Subject to technical modification 03.2014 ',
    CONTACTLINE1: 'Selux GmbH, Volkmarstr. 18, D-12099 Berlin, T +49 30 72001-0, F-100',
    LUMINAIRE: 'Luminaire',
    BRACKET: 'Bracket',
    POLE: 'Pole',
    WOODPOLE: 'Wooden pole',
    HEIGHT: 'Height',
    DIAMETER: 'Diameter',
    DEGREE_ROTATION: 'Angle',
    LAMP: 'Lamp',
    COLOR: 'Color',
    POWER: 'Power',
    DISTRIBUTION: 'Distribution',
    DRILLINTRO: 'Leuchtenanschluss von Mastpitze ausgehend',
    DRILLINTROFLORACION: 'Leuchtenanschluss von Mastunterkante (ohne Fußplatte)',
    HOLENUM: 'Anschlusspunkt',
    HOLELUMHEIGHT: 'Lichtpunkthöhe',
    HOLEHEIGHT: 'Anschlussbohrung',
    HOLEANGLE: 'Drehung',
    COMPANY: 'Company',
    CONTACT: 'Contact',
    PHONE: 'Phone',
    EMAIL: 'EMail Address',
    PROJECTNAMEID: 'Project Name/ID',
    PROJECTNAME: 'Project Name',
    PROJECTID: 'ID',
    PROJECTADDRESS: 'Project Address',
    PROJECTNOTE: 'Project Note',
    MESSAGE: 'Your Message',
    STREET: 'Street',
    NR: 'No.',
    CITY: 'City',
    ZIP: 'ZIP',
    COUNTRY: 'Country',
    SEND: 'Send',
    CLOSE: 'Close',
    SENDING: 'Sending Request ...',
    SENDINGSUCCESS: 'Request recieved!',
    SENDINGERROR: 'Error: Could not send request!',
    ARTICLENUMBER: 'Article Number',
    PRICE: 'Price',
    PIECES: 'Pieces',
    SUM: "Total",
    DISPLAYPRICES: "show gross prices",
    DISPLAYNUMBERS: "show article numbers",
    DISPLAYDRILLHOLES: "show drill holes for the production",
    CONFIRMATIONHEAD: "costumer‘s conformation",
    CONFIRMATIONSIGNATURE: "signature/stamp/date",
    GOBO_LENS: 'Lens',
    ANCHOR: 'Buried base'
  },
  PRICE: {
    SUBTOTAL: 'Brutto Subtotal',
    PIECES: 'Pieces'
  },
  COLORS: {
    SELUXGRAPHITE: 'Selux Graphite',
    RAL9005: 'Jet black',
    RAL7016: 'Antracite grey',
    RAL7024: 'Graphite grey',
    RAL7011: 'Iron grey',
    RAL9007: 'Grey aluminium',
    RAL9006: 'White aluminium',
    RAL9010: 'Pure white',
    RAL9016: 'Traffic white',
    RAL6009: 'Pine green',
    RAL6005: 'Moss green',
    RAL5003: 'Sapphire blue',
    RAL3005: 'Wine red',
    RAL3003: 'Ruby red',
    DB703: 'Pearled dark grey',
    DB702: 'Pearled silver grey',
    DB701: 'Pearled white aluminium',

    LIVERPOOL: 'Liverpool',
    SANSSOUCI: 'Sanssouci',
    VERSAILLE: 'Versaille',
    BLACKMATT: 'Black Matt',

    WOOD_REDWOOD: 'Red Wood',
    WOOD_CANADIANBROWN: 'Canadian Brown',
    WOOD_COOLSCANDINAVIAN: 'Cool Scandinavian',
    WOOD_TENERIFFAGREY: 'Teneriffa Grey',
    WOOD_ROCKYMOUNTAINGREY: 'Rocky Mountain Grey',
    WOOD_HIMALAYAGREY: 'Himalaya Grey',
  },
  EOF: 'EOF'
};
